<template>

  <span>
    <font-awesome-icon icon="exclamation-circle" size="lg" class="red--text" v-if="alarm.severity === 'error'"></font-awesome-icon>
    <font-awesome-icon icon="exclamation-triangle" size="lg" class="orange--text" v-if="alarm.severity === 'warning'"></font-awesome-icon>
    <font-awesome-icon icon="retweet" size="lg" class="orange--text" v-if="alarm.severity === 'repeatable'"></font-awesome-icon>
  </span>

</template>

<script>
  export default {
    name: 'alarm-severity',

    props: [ 'alarm' ]
  }
</script>

<style scoped lang="scss">

</style>
